import {APIErrorStatus} from "../utils/modalText"
import {API} from './apiAuth';
export const sendApiFunc = async (ex, data) => {
  let lowerEx = ex.toLowerCase();
  try {
    const response = await API.post(`${lowerEx}/api-key`,data
    );
    return response;
  } catch (error) {
    APIErrorStatus(error);
  }
}

export const getConnectedApiFunc = async () => {
  try {
    const response = await API.get('connected-exchanges');
    return response;
  } catch (error) {
    // console.error('send API Error', error);
    // throw error;
    APIErrorStatus(error)
  }
}

export const deleteApiFunc = async (ex) => {
  // // console.log('ex',ex);
  let lowerEx = ex.toLowerCase();
  // // console.log('lowerEx',lowerEx);
  try {
    const response = await API.delete(`${lowerEx}/api-key`);
    return response;
  } catch (error) {
    // console.error('send API Error', error);
    // throw error;
    APIErrorStatus(error)
  }
}

export const editApiFunc = async (ex, data) => {
  let lowerEx = ex.toLowerCase();
  try {
    const response = await API.put(`${lowerEx}/api-key`,data
    );
    return response;
  } catch (error) {
    // console.error('send API Error', error);
    APIErrorStatus(error)
  }
}